export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Define a Relay Cursor type:
   * https://relay.dev/graphql/connections.htm#sec-Cursor
   */
  Cursor: { input: any; output: any; }
  /** The builtin Time type */
  Time: { input: string; output: string; }
};

export type Biography = Node & {
  __typename?: 'Biography';
  id: Scalars['ID']['output'];
  profile: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userPublicProfile: UserPublicProfile;
  userPublicProfileID: Scalars['ID']['output'];
};

/**
 * BiographyWhereInput is used for filtering Biography objects.
 * Input was generated by ent.
 */
export type BiographyWhereInput = {
  and?: InputMaybe<Array<BiographyWhereInput>>;
  /** user_public_profile edge predicates */
  hasUserPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserPublicProfileWith?: InputMaybe<Array<UserPublicProfileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<BiographyWhereInput>;
  or?: InputMaybe<Array<BiographyWhereInput>>;
  /** profile field predicates */
  profile?: InputMaybe<Scalars['String']['input']>;
  profileContains?: InputMaybe<Scalars['String']['input']>;
  profileContainsFold?: InputMaybe<Scalars['String']['input']>;
  profileEqualFold?: InputMaybe<Scalars['String']['input']>;
  profileGT?: InputMaybe<Scalars['String']['input']>;
  profileGTE?: InputMaybe<Scalars['String']['input']>;
  profileHasPrefix?: InputMaybe<Scalars['String']['input']>;
  profileHasSuffix?: InputMaybe<Scalars['String']['input']>;
  profileIn?: InputMaybe<Array<Scalars['String']['input']>>;
  profileLT?: InputMaybe<Scalars['String']['input']>;
  profileLTE?: InputMaybe<Scalars['String']['input']>;
  profileNEQ?: InputMaybe<Scalars['String']['input']>;
  profileNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_public_profile_id field predicates */
  userPublicProfileID?: InputMaybe<Scalars['ID']['input']>;
  userPublicProfileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userPublicProfileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userPublicProfileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * CreateGroupSessionInput is used for create GroupSession object.
 * Input was generated by ent.
 */
export type CreateGroupSessionInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  durationSeconds: Scalars['Int']['input'];
  onlineInfoID?: InputMaybe<Scalars['ID']['input']>;
  ownerID: Scalars['ID']['input'];
  permission?: InputMaybe<GroupSessionPermission>;
  requestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  startTimeUtc: Scalars['Time']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  venueID?: InputMaybe<Scalars['ID']['input']>;
  visibility?: InputMaybe<GroupSessionVisibility>;
};

/**
 * CreateMentorTimetableInput is used for create MentorTimetable object.
 * Input was generated by ent.
 */
export type CreateMentorTimetableInput = {
  acceptReservation?: InputMaybe<Scalars['Boolean']['input']>;
  ownerID: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateOneOneSessionAppointmentInput is used for create OneOneSessionAppointment object.
 * Input was generated by ent.
 */
export type CreateOneOneSessionAppointmentInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  durationSeconds: Scalars['Int']['input'];
  endTime: Scalars['Time']['input'];
  googleCalendarEventID?: InputMaybe<Scalars['ID']['input']>;
  requestID: Scalars['ID']['input'];
  /** UTC timestamp secodns */
  startTime: Scalars['Time']['input'];
  status?: InputMaybe<OneOneSessionAppointmentStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateOneOneSessionRequestInput is used for create OneOneSessionRequest object.
 * Input was generated by ent.
 */
export type CreateOneOneSessionRequestInput = {
  appointmentID?: InputMaybe<Scalars['ID']['input']>;
  conversationID?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  feedbackIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerID: Scalars['ID']['input'];
  sessionTemplateID: Scalars['ID']['input'];
  status?: InputMaybe<OneOneSessionRequestStatus>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateOneOneSessionTemplateInput is used for create OneOneSessionTemplate object.
 * Input was generated by ent.
 */
export type CreateOneOneSessionTemplateInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  durationSeconds: Scalars['Int']['input'];
  ownerID: Scalars['ID']['input'];
  requestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  topic?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateUserInput is used for create User object.
 * Input was generated by ent.
 */
export type CreateUserInput = {
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  emailCredentialID?: InputMaybe<Scalars['ID']['input']>;
  googleCredentialID?: InputMaybe<Scalars['ID']['input']>;
  loginSessionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownGroupSessionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownGroupSessionRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownMentorTimetableID?: InputMaybe<Scalars['ID']['input']>;
  ownOneOneSessionFeedbackIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownOneOneSessionRequestIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownOneOneSessionTemplateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownWeeklyCalendarID?: InputMaybe<Scalars['ID']['input']>;
  publicProfileID?: InputMaybe<Scalars['ID']['input']>;
  superuserProfileID?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * CreateVenueInput is used for create Venue object.
 * Input was generated by ent.
 */
export type CreateVenueInput = {
  fullAddress: Scalars['String']['input'];
  mapURL?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  station: Scalars['String']['input'];
};

export type EmailCredential = Node & {
  __typename?: 'EmailCredential';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  ownerID: Scalars['ID']['output'];
};

/**
 * EmailCredentialWhereInput is used for filtering EmailCredential objects.
 * Input was generated by ent.
 */
export type EmailCredentialWhereInput = {
  and?: InputMaybe<Array<EmailCredentialWhereInput>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<EmailCredentialWhereInput>;
  or?: InputMaybe<Array<EmailCredentialWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  id: Scalars['String']['output'];
  login: Scalars['Boolean']['output'];
  mentorshipRequest: Scalars['Boolean']['output'];
  signup: Scalars['Boolean']['output'];
  submitFeedback: Scalars['Boolean']['output'];
};

export type GoogleCalendarEvent = Node & {
  __typename?: 'GoogleCalendarEvent';
  appointment: OneOneSessionAppointment;
  appointmentID: Scalars['ID']['output'];
  createdAt: Scalars['Time']['output'];
  eventID: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  meetingLink: Scalars['String']['output'];
};

/**
 * GoogleCalendarEventWhereInput is used for filtering GoogleCalendarEvent objects.
 * Input was generated by ent.
 */
export type GoogleCalendarEventWhereInput = {
  and?: InputMaybe<Array<GoogleCalendarEventWhereInput>>;
  /** appointment_id field predicates */
  appointmentID?: InputMaybe<Scalars['ID']['input']>;
  appointmentIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  appointmentIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  appointmentIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** event_id field predicates */
  eventID?: InputMaybe<Scalars['String']['input']>;
  eventIDContains?: InputMaybe<Scalars['String']['input']>;
  eventIDContainsFold?: InputMaybe<Scalars['String']['input']>;
  eventIDEqualFold?: InputMaybe<Scalars['String']['input']>;
  eventIDGT?: InputMaybe<Scalars['String']['input']>;
  eventIDGTE?: InputMaybe<Scalars['String']['input']>;
  eventIDHasPrefix?: InputMaybe<Scalars['String']['input']>;
  eventIDHasSuffix?: InputMaybe<Scalars['String']['input']>;
  eventIDIn?: InputMaybe<Array<Scalars['String']['input']>>;
  eventIDLT?: InputMaybe<Scalars['String']['input']>;
  eventIDLTE?: InputMaybe<Scalars['String']['input']>;
  eventIDNEQ?: InputMaybe<Scalars['String']['input']>;
  eventIDNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** appointment edge predicates */
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointmentWith?: InputMaybe<Array<OneOneSessionAppointmentWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** meeting_link field predicates */
  meetingLink?: InputMaybe<Scalars['String']['input']>;
  meetingLinkContains?: InputMaybe<Scalars['String']['input']>;
  meetingLinkContainsFold?: InputMaybe<Scalars['String']['input']>;
  meetingLinkEqualFold?: InputMaybe<Scalars['String']['input']>;
  meetingLinkGT?: InputMaybe<Scalars['String']['input']>;
  meetingLinkGTE?: InputMaybe<Scalars['String']['input']>;
  meetingLinkHasPrefix?: InputMaybe<Scalars['String']['input']>;
  meetingLinkHasSuffix?: InputMaybe<Scalars['String']['input']>;
  meetingLinkIn?: InputMaybe<Array<Scalars['String']['input']>>;
  meetingLinkLT?: InputMaybe<Scalars['String']['input']>;
  meetingLinkLTE?: InputMaybe<Scalars['String']['input']>;
  meetingLinkNEQ?: InputMaybe<Scalars['String']['input']>;
  meetingLinkNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<GoogleCalendarEventWhereInput>;
  or?: InputMaybe<Array<GoogleCalendarEventWhereInput>>;
};

export type GoogleCredential = Node & {
  __typename?: 'GoogleCredential';
  email: Scalars['String']['output'];
  hasMeetScopes: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  ownerID: Scalars['ID']['output'];
};

/**
 * GoogleCredentialWhereInput is used for filtering GoogleCredential objects.
 * Input was generated by ent.
 */
export type GoogleCredentialWhereInput = {
  and?: InputMaybe<Array<GoogleCredentialWhereInput>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<GoogleCredentialWhereInput>;
  or?: InputMaybe<Array<GoogleCredentialWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GroupSession = Node & {
  __typename?: 'GroupSession';
  capacity?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Time']['output'];
  durationSeconds: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  onlineInfo?: Maybe<GroupSessionOnlineInfo>;
  owner: User;
  ownerID: Scalars['ID']['output'];
  permission: GroupSessionPermission;
  requests?: Maybe<Array<GroupSessionRequest>>;
  startTimeUTCSeconds: Scalars['Int']['output'];
  startTimeUtc: Scalars['Time']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  venue?: Maybe<Venue>;
  venueID?: Maybe<Scalars['ID']['output']>;
  visibility: GroupSessionVisibility;
};

/** A connection to a list of items. */
export type GroupSessionConnection = {
  __typename?: 'GroupSessionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GroupSessionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GroupSessionEdge = {
  __typename?: 'GroupSessionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GroupSession>;
};

export type GroupSessionOnlineInfo = Node & {
  __typename?: 'GroupSessionOnlineInfo';
  createdAt: Scalars['Time']['output'];
  groupSession: GroupSession;
  groupSessionID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  joinableTime: Scalars['Time']['output'];
  updatedAt: Scalars['Time']['output'];
  url: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type GroupSessionOnlineInfoConnection = {
  __typename?: 'GroupSessionOnlineInfoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GroupSessionOnlineInfoEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GroupSessionOnlineInfoEdge = {
  __typename?: 'GroupSessionOnlineInfoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GroupSessionOnlineInfo>;
};

/**
 * GroupSessionOnlineInfoWhereInput is used for filtering GroupSessionOnlineInfo objects.
 * Input was generated by ent.
 */
export type GroupSessionOnlineInfoWhereInput = {
  and?: InputMaybe<Array<GroupSessionOnlineInfoWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** group_session_id field predicates */
  groupSessionID?: InputMaybe<Scalars['ID']['input']>;
  groupSessionIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupSessionIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  groupSessionIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** group_session edge predicates */
  hasGroupSession?: InputMaybe<Scalars['Boolean']['input']>;
  hasGroupSessionWith?: InputMaybe<Array<GroupSessionWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** joinable_time field predicates */
  joinableTime?: InputMaybe<Scalars['Time']['input']>;
  joinableTimeGT?: InputMaybe<Scalars['Time']['input']>;
  joinableTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  joinableTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  joinableTimeLT?: InputMaybe<Scalars['Time']['input']>;
  joinableTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  joinableTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  joinableTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  not?: InputMaybe<GroupSessionOnlineInfoWhereInput>;
  or?: InputMaybe<Array<GroupSessionOnlineInfoWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** url field predicates */
  url?: InputMaybe<Scalars['String']['input']>;
  urlContains?: InputMaybe<Scalars['String']['input']>;
  urlContainsFold?: InputMaybe<Scalars['String']['input']>;
  urlEqualFold?: InputMaybe<Scalars['String']['input']>;
  urlGT?: InputMaybe<Scalars['String']['input']>;
  urlGTE?: InputMaybe<Scalars['String']['input']>;
  urlHasPrefix?: InputMaybe<Scalars['String']['input']>;
  urlHasSuffix?: InputMaybe<Scalars['String']['input']>;
  urlIn?: InputMaybe<Array<Scalars['String']['input']>>;
  urlLT?: InputMaybe<Scalars['String']['input']>;
  urlLTE?: InputMaybe<Scalars['String']['input']>;
  urlNEQ?: InputMaybe<Scalars['String']['input']>;
  urlNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Ordering options for GroupSession connections */
export type GroupSessionOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order GroupSessions. */
  field: GroupSessionOrderField;
};

/** Properties by which GroupSession connections can be ordered. */
export enum GroupSessionOrderField {
  StartTimeUtc = 'START_TIME_UTC'
}

/** GroupSessionPermission is enum for the field permission */
export enum GroupSessionPermission {
  Closed = 'closed',
  MemberOnly = 'memberOnly',
  Public = 'public'
}

export type GroupSessionRequest = Node & {
  __typename?: 'GroupSessionRequest';
  channel?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  groupSession: GroupSession;
  groupSessionID: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  ownerID?: Maybe<Scalars['ID']['output']>;
  status: GroupSessionRequestStatus;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type GroupSessionRequestConnection = {
  __typename?: 'GroupSessionRequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GroupSessionRequestEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GroupSessionRequestEdge = {
  __typename?: 'GroupSessionRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GroupSessionRequest>;
};

/** GroupSessionRequestStatus is enum for the field status */
export enum GroupSessionRequestStatus {
  Attended = 'attended',
  Cancelled = 'cancelled',
  Confirmed = 'confirmed',
  Pending = 'pending',
  Waitlist = 'waitlist'
}

/**
 * GroupSessionRequestWhereInput is used for filtering GroupSessionRequest objects.
 * Input was generated by ent.
 */
export type GroupSessionRequestWhereInput = {
  and?: InputMaybe<Array<GroupSessionRequestWhereInput>>;
  /** channel field predicates */
  channel?: InputMaybe<Scalars['String']['input']>;
  channelContains?: InputMaybe<Scalars['String']['input']>;
  channelContainsFold?: InputMaybe<Scalars['String']['input']>;
  channelEqualFold?: InputMaybe<Scalars['String']['input']>;
  channelGT?: InputMaybe<Scalars['String']['input']>;
  channelGTE?: InputMaybe<Scalars['String']['input']>;
  channelHasPrefix?: InputMaybe<Scalars['String']['input']>;
  channelHasSuffix?: InputMaybe<Scalars['String']['input']>;
  channelIn?: InputMaybe<Array<Scalars['String']['input']>>;
  channelIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  channelLT?: InputMaybe<Scalars['String']['input']>;
  channelLTE?: InputMaybe<Scalars['String']['input']>;
  channelNEQ?: InputMaybe<Scalars['String']['input']>;
  channelNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  channelNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** company field predicates */
  company?: InputMaybe<Scalars['String']['input']>;
  companyContains?: InputMaybe<Scalars['String']['input']>;
  companyContainsFold?: InputMaybe<Scalars['String']['input']>;
  companyEqualFold?: InputMaybe<Scalars['String']['input']>;
  companyGT?: InputMaybe<Scalars['String']['input']>;
  companyGTE?: InputMaybe<Scalars['String']['input']>;
  companyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  companyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  companyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  companyIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  companyLT?: InputMaybe<Scalars['String']['input']>;
  companyLTE?: InputMaybe<Scalars['String']['input']>;
  companyNEQ?: InputMaybe<Scalars['String']['input']>;
  companyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  companyNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email field predicates */
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  emailContainsFold?: InputMaybe<Scalars['String']['input']>;
  emailEqualFold?: InputMaybe<Scalars['String']['input']>;
  emailGT?: InputMaybe<Scalars['String']['input']>;
  emailGTE?: InputMaybe<Scalars['String']['input']>;
  emailHasPrefix?: InputMaybe<Scalars['String']['input']>;
  emailHasSuffix?: InputMaybe<Scalars['String']['input']>;
  emailIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  emailLT?: InputMaybe<Scalars['String']['input']>;
  emailLTE?: InputMaybe<Scalars['String']['input']>;
  emailNEQ?: InputMaybe<Scalars['String']['input']>;
  emailNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  emailNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** firstName field predicates */
  firstname?: InputMaybe<Scalars['String']['input']>;
  firstnameContains?: InputMaybe<Scalars['String']['input']>;
  firstnameContainsFold?: InputMaybe<Scalars['String']['input']>;
  firstnameEqualFold?: InputMaybe<Scalars['String']['input']>;
  firstnameGT?: InputMaybe<Scalars['String']['input']>;
  firstnameGTE?: InputMaybe<Scalars['String']['input']>;
  firstnameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  firstnameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  firstnameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstnameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  firstnameLT?: InputMaybe<Scalars['String']['input']>;
  firstnameLTE?: InputMaybe<Scalars['String']['input']>;
  firstnameNEQ?: InputMaybe<Scalars['String']['input']>;
  firstnameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstnameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** group_session_id field predicates */
  groupSessionID?: InputMaybe<Scalars['ID']['input']>;
  groupSessionIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  groupSessionIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  groupSessionIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** group_session edge predicates */
  hasGroupSession?: InputMaybe<Scalars['Boolean']['input']>;
  hasGroupSessionWith?: InputMaybe<Array<GroupSessionWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** lastName field predicates */
  lastname?: InputMaybe<Scalars['String']['input']>;
  lastnameContains?: InputMaybe<Scalars['String']['input']>;
  lastnameContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastnameEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastnameGT?: InputMaybe<Scalars['String']['input']>;
  lastnameGTE?: InputMaybe<Scalars['String']['input']>;
  lastnameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastnameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastnameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastnameIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  lastnameLT?: InputMaybe<Scalars['String']['input']>;
  lastnameLTE?: InputMaybe<Scalars['String']['input']>;
  lastnameNEQ?: InputMaybe<Scalars['String']['input']>;
  lastnameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastnameNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<GroupSessionRequestWhereInput>;
  or?: InputMaybe<Array<GroupSessionRequestWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** status field predicates */
  status?: InputMaybe<GroupSessionRequestStatus>;
  statusIn?: InputMaybe<Array<GroupSessionRequestStatus>>;
  statusNEQ?: InputMaybe<GroupSessionRequestStatus>;
  statusNotIn?: InputMaybe<Array<GroupSessionRequestStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** GroupSessionVisibility is enum for the field visibility */
export enum GroupSessionVisibility {
  Private = 'private',
  Public = 'public',
  Unlisted = 'unlisted'
}

/**
 * GroupSessionWhereInput is used for filtering GroupSession objects.
 * Input was generated by ent.
 */
export type GroupSessionWhereInput = {
  and?: InputMaybe<Array<GroupSessionWhereInput>>;
  /** capacity field predicates */
  capacity?: InputMaybe<Scalars['Int']['input']>;
  capacityGT?: InputMaybe<Scalars['Int']['input']>;
  capacityGTE?: InputMaybe<Scalars['Int']['input']>;
  capacityIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  capacityIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  capacityLT?: InputMaybe<Scalars['Int']['input']>;
  capacityLTE?: InputMaybe<Scalars['Int']['input']>;
  capacityNEQ?: InputMaybe<Scalars['Int']['input']>;
  capacityNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  capacityNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** duration_seconds field predicates */
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  durationSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** online_info edge predicates */
  hasOnlineInfo?: InputMaybe<Scalars['Boolean']['input']>;
  hasOnlineInfoWith?: InputMaybe<Array<GroupSessionOnlineInfoWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** requests edge predicates */
  hasRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequestsWith?: InputMaybe<Array<GroupSessionRequestWhereInput>>;
  /** venue edge predicates */
  hasVenue?: InputMaybe<Scalars['Boolean']['input']>;
  hasVenueWith?: InputMaybe<Array<VenueWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<GroupSessionWhereInput>;
  or?: InputMaybe<Array<GroupSessionWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** permission field predicates */
  permission?: InputMaybe<GroupSessionPermission>;
  permissionIn?: InputMaybe<Array<GroupSessionPermission>>;
  permissionNEQ?: InputMaybe<GroupSessionPermission>;
  permissionNotIn?: InputMaybe<Array<GroupSessionPermission>>;
  /** start_time_utc field predicates */
  startTimeUtc?: InputMaybe<Scalars['Time']['input']>;
  startTimeUtcGT?: InputMaybe<Scalars['Time']['input']>;
  startTimeUtcGTE?: InputMaybe<Scalars['Time']['input']>;
  startTimeUtcIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startTimeUtcLT?: InputMaybe<Scalars['Time']['input']>;
  startTimeUtcLTE?: InputMaybe<Scalars['Time']['input']>;
  startTimeUtcNEQ?: InputMaybe<Scalars['Time']['input']>;
  startTimeUtcNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** venue_id field predicates */
  venueID?: InputMaybe<Scalars['ID']['input']>;
  venueIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIDIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  venueIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  venueIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIDNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** visibility field predicates */
  visibility?: InputMaybe<GroupSessionVisibility>;
  visibilityIn?: InputMaybe<Array<GroupSessionVisibility>>;
  visibilityNEQ?: InputMaybe<GroupSessionVisibility>;
  visibilityNotIn?: InputMaybe<Array<GroupSessionVisibility>>;
};

export type LoginSession = Node & {
  __typename?: 'LoginSession';
  id: Scalars['ID']['output'];
  lastLoginTime: Scalars['Time']['output'];
  owner: User;
  ownerID: Scalars['ID']['output'];
};

/**
 * LoginSessionWhereInput is used for filtering LoginSession objects.
 * Input was generated by ent.
 */
export type LoginSessionWhereInput = {
  and?: InputMaybe<Array<LoginSessionWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** last_login_time field predicates */
  lastLoginTime?: InputMaybe<Scalars['Time']['input']>;
  lastLoginTimeGT?: InputMaybe<Scalars['Time']['input']>;
  lastLoginTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  lastLoginTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  lastLoginTimeLT?: InputMaybe<Scalars['Time']['input']>;
  lastLoginTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  lastLoginTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  lastLoginTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  not?: InputMaybe<LoginSessionWhereInput>;
  or?: InputMaybe<Array<LoginSessionWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MentorTimetable = Node & {
  __typename?: 'MentorTimetable';
  acceptReservation: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isOwnedByViewer: Scalars['Boolean']['output'];
  owner: User;
  ownerID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  weeklyTimetable?: Maybe<WeeklyTimetable>;
};

/** A connection to a list of items. */
export type MentorTimetableConnection = {
  __typename?: 'MentorTimetableConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MentorTimetableEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MentorTimetableEdge = {
  __typename?: 'MentorTimetableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MentorTimetable>;
};

/**
 * MentorTimetableWhereInput is used for filtering MentorTimetable objects.
 * Input was generated by ent.
 */
export type MentorTimetableWhereInput = {
  /** accept_reservation field predicates */
  acceptReservation?: InputMaybe<Scalars['Boolean']['input']>;
  acceptReservationNEQ?: InputMaybe<Scalars['Boolean']['input']>;
  and?: InputMaybe<Array<MentorTimetableWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<MentorTimetableWhereInput>;
  or?: InputMaybe<Array<MentorTimetableWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  confirmResetPassword: Scalars['Boolean']['output'];
  confirmUserEmailSignup?: Maybe<UserToken>;
  createProfilePhotoUploadUrl?: Maybe<Scalars['String']['output']>;
  emailLogin?: Maybe<UserToken>;
  guestCreateGroupSessionRequest: Scalars['Boolean']['output'];
  logout: Scalars['Boolean']['output'];
  noop: Scalars['Boolean']['output'];
  registerPublicityEvent?: Maybe<Scalars['Boolean']['output']>;
  removeProfilePhoto?: Maybe<UserPublicProfile>;
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  submitOneOneSessionFeedback?: Maybe<OneOneSessionFeedback>;
  upsertBiography?: Maybe<Biography>;
  upsertGroupSession?: Maybe<GroupSession>;
  upsertProfession?: Maybe<Profession>;
  upsertUniversityEducation?: Maybe<UniversityEducation>;
  upsertUserPublicProfile?: Maybe<UserPublicProfile>;
  upsertVenue?: Maybe<Venue>;
  userEmailSignup?: Maybe<Scalars['Boolean']['output']>;
  viewerCreateGroupSessionRequest?: Maybe<GroupSessionRequest>;
  viewerCreateOneOneSessionRequest?: Maybe<OneOneSessionRequest>;
  viewerDeleteGoogleCredential: Scalars['Boolean']['output'];
  viewerDeregisterGroupSession: Scalars['Boolean']['output'];
  viewerRescheduleAppointment?: Maybe<OneOneSessionAppointment>;
  viewerSelfCheckInGroupSession: Scalars['Boolean']['output'];
  viewerSetGoogleTokenWithNonAuthScopes: Scalars['Boolean']['output'];
  viewerSetMentorTimetableAcceptReservation?: Maybe<MentorTimetable>;
  viewerSetOneOneSessionAppointmentStatus?: Maybe<OneOneSessionAppointment>;
  viewerSetOneOneSessionRequestStatus?: Maybe<OneOneSessionRequest>;
  viewerSetPublicProfileGoal?: Maybe<UserPublicProfile>;
  viewerSetWeeklyCalendar?: Maybe<WeeklyCalendar>;
};


export type MutationConfirmResetPasswordArgs = {
  rawPassword: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};


export type MutationConfirmUserEmailSignupArgs = {
  emailSignupToken: Scalars['String']['input'];
  rawPassword: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
};


export type MutationCreateProfilePhotoUploadUrlArgs = {
  md5: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationEmailLoginArgs = {
  email: Scalars['String']['input'];
  rawPassword: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
};


export type MutationGuestCreateGroupSessionRequestArgs = {
  channel: Scalars['String']['input'];
  company: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  sessionID: Scalars['ID']['input'];
};


export type MutationRegisterPublicityEventArgs = {
  input?: InputMaybe<PublicityEventInput>;
};


export type MutationRemoveProfilePhotoArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSubmitOneOneSessionFeedbackArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
  requestID: Scalars['ID']['input'];
};


export type MutationUpsertBiographyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  profile: Scalars['String']['input'];
  userPublicProfileID: Scalars['ID']['input'];
};


export type MutationUpsertGroupSessionArgs = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  durationSeconds: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  startTimeUTC: Scalars['Int']['input'];
  title: Scalars['String']['input'];
  venueID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpsertProfessionArgs = {
  company: Scalars['String']['input'];
  department?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  specialty: Array<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  userPublicProfileID: Scalars['ID']['input'];
};


export type MutationUpsertUniversityEducationArgs = {
  estimatedGraduationYear: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  major: Scalars['String']['input'];
  schoolName: Scalars['String']['input'];
  userPublicProfileID: Scalars['ID']['input'];
  yearOfStudy: UniversityEducationYearOfStudy;
};


export type MutationUpsertUserPublicProfileArgs = {
  firstName: Scalars['String']['input'];
  gender: UserPublicProfileGender;
  id?: InputMaybe<Scalars['ID']['input']>;
  language: Array<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
};


export type MutationUpsertVenueArgs = {
  fullAddress: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  mapUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  station: Scalars['String']['input'];
};


export type MutationUserEmailSignupArgs = {
  email: Scalars['String']['input'];
  nextUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationViewerCreateGroupSessionRequestArgs = {
  channel: Scalars['String']['input'];
  sessionID: Scalars['ID']['input'];
};


export type MutationViewerCreateOneOneSessionRequestArgs = {
  message: Scalars['String']['input'];
  sessionTemplateID: Scalars['ID']['input'];
  startTimeUTCSeconds: Scalars['Int']['input'];
};


export type MutationViewerDeregisterGroupSessionArgs = {
  sessionID: Scalars['ID']['input'];
};


export type MutationViewerRescheduleAppointmentArgs = {
  reason: Scalars['String']['input'];
  requestID: Scalars['ID']['input'];
  startTimeUTCSeconds: Scalars['Int']['input'];
};


export type MutationViewerSelfCheckInGroupSessionArgs = {
  sessionID: Scalars['ID']['input'];
};


export type MutationViewerSetGoogleTokenWithNonAuthScopesArgs = {
  authCode: Scalars['String']['input'];
};


export type MutationViewerSetMentorTimetableAcceptReservationArgs = {
  acceptReservation: Scalars['Boolean']['input'];
};


export type MutationViewerSetOneOneSessionAppointmentStatusArgs = {
  appointmentID: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  status: OneOneSessionAppointmentStatus;
};


export type MutationViewerSetOneOneSessionRequestStatusArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  requestID: Scalars['ID']['input'];
  status: OneOneSessionRequestStatus;
};


export type MutationViewerSetPublicProfileGoalArgs = {
  goal: UserPublicProfileGoal;
};


export type MutationViewerSetWeeklyCalendarArgs = {
  input: WeeklyTimetableInput;
};

/**
 * An object with an ID.
 * Follows the [Relay Global Object Identification Specification](https://relay.dev/graphql/objectidentification.htm)
 */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
};

export type OneOneSessionAppointment = Node & {
  __typename?: 'OneOneSessionAppointment';
  createdAt: Scalars['Time']['output'];
  durationSeconds: Scalars['Int']['output'];
  endTime: Scalars['Time']['output'];
  googleCalendarEvent?: Maybe<GoogleCalendarEvent>;
  id: Scalars['ID']['output'];
  request: OneOneSessionRequest;
  requestID: Scalars['ID']['output'];
  /** UTC timestamp secodns */
  startTime: Scalars['Time']['output'];
  status: OneOneSessionAppointmentStatus;
  updatedAt: Scalars['Time']['output'];
  viewerVideoSessionToken?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type OneOneSessionAppointmentConnection = {
  __typename?: 'OneOneSessionAppointmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OneOneSessionAppointmentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OneOneSessionAppointmentEdge = {
  __typename?: 'OneOneSessionAppointmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OneOneSessionAppointment>;
};

/** OneOneSessionAppointmentStatus is enum for the field status */
export enum OneOneSessionAppointmentStatus {
  Accepted = 'accepted',
  Declined = 'declined',
  Pending = 'pending'
}

/**
 * OneOneSessionAppointmentWhereInput is used for filtering OneOneSessionAppointment objects.
 * Input was generated by ent.
 */
export type OneOneSessionAppointmentWhereInput = {
  and?: InputMaybe<Array<OneOneSessionAppointmentWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** duration_seconds field predicates */
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  durationSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** end_time field predicates */
  endTime?: InputMaybe<Scalars['Time']['input']>;
  endTimeGT?: InputMaybe<Scalars['Time']['input']>;
  endTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  endTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  endTimeLT?: InputMaybe<Scalars['Time']['input']>;
  endTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  endTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  endTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** google_calendar_event edge predicates */
  hasGoogleCalendarEvent?: InputMaybe<Scalars['Boolean']['input']>;
  hasGoogleCalendarEventWith?: InputMaybe<Array<GoogleCalendarEventWhereInput>>;
  /** request edge predicates */
  hasRequest?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequestWith?: InputMaybe<Array<OneOneSessionRequestWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OneOneSessionAppointmentWhereInput>;
  or?: InputMaybe<Array<OneOneSessionAppointmentWhereInput>>;
  /** request_id field predicates */
  requestID?: InputMaybe<Scalars['ID']['input']>;
  requestIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  requestIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** start_time field predicates */
  startTime?: InputMaybe<Scalars['Time']['input']>;
  startTimeGT?: InputMaybe<Scalars['Time']['input']>;
  startTimeGTE?: InputMaybe<Scalars['Time']['input']>;
  startTimeIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  startTimeLT?: InputMaybe<Scalars['Time']['input']>;
  startTimeLTE?: InputMaybe<Scalars['Time']['input']>;
  startTimeNEQ?: InputMaybe<Scalars['Time']['input']>;
  startTimeNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** status field predicates */
  status?: InputMaybe<OneOneSessionAppointmentStatus>;
  statusIn?: InputMaybe<Array<OneOneSessionAppointmentStatus>>;
  statusNEQ?: InputMaybe<OneOneSessionAppointmentStatus>;
  statusNotIn?: InputMaybe<Array<OneOneSessionAppointmentStatus>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type OneOneSessionConversation = Node & {
  __typename?: 'OneOneSessionConversation';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  lastMessage?: Maybe<ThreadMessage>;
  request: OneOneSessionRequest;
  requestID: Scalars['ID']['output'];
  thread: Thread;
  updatedAt: Scalars['Time']['output'];
};

/**
 * OneOneSessionConversationWhereInput is used for filtering OneOneSessionConversation objects.
 * Input was generated by ent.
 */
export type OneOneSessionConversationWhereInput = {
  and?: InputMaybe<Array<OneOneSessionConversationWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** request edge predicates */
  hasRequest?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequestWith?: InputMaybe<Array<OneOneSessionRequestWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OneOneSessionConversationWhereInput>;
  or?: InputMaybe<Array<OneOneSessionConversationWhereInput>>;
  /** request_id field predicates */
  requestID?: InputMaybe<Scalars['ID']['input']>;
  requestIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  requestIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type OneOneSessionFeedback = Node & {
  __typename?: 'OneOneSessionFeedback';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  ownerID: Scalars['ID']['output'];
  rating?: Maybe<Scalars['Int']['output']>;
  request: OneOneSessionRequest;
  requestID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/**
 * OneOneSessionFeedbackWhereInput is used for filtering OneOneSessionFeedback objects.
 * Input was generated by ent.
 */
export type OneOneSessionFeedbackWhereInput = {
  and?: InputMaybe<Array<OneOneSessionFeedbackWhereInput>>;
  /** comment field predicates */
  comment?: InputMaybe<Scalars['String']['input']>;
  commentContains?: InputMaybe<Scalars['String']['input']>;
  commentContainsFold?: InputMaybe<Scalars['String']['input']>;
  commentEqualFold?: InputMaybe<Scalars['String']['input']>;
  commentGT?: InputMaybe<Scalars['String']['input']>;
  commentGTE?: InputMaybe<Scalars['String']['input']>;
  commentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  commentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  commentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  commentLT?: InputMaybe<Scalars['String']['input']>;
  commentLTE?: InputMaybe<Scalars['String']['input']>;
  commentNEQ?: InputMaybe<Scalars['String']['input']>;
  commentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  commentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** request edge predicates */
  hasRequest?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequestWith?: InputMaybe<Array<OneOneSessionRequestWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OneOneSessionFeedbackWhereInput>;
  or?: InputMaybe<Array<OneOneSessionFeedbackWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** rating field predicates */
  rating?: InputMaybe<Scalars['Int']['input']>;
  ratingGT?: InputMaybe<Scalars['Int']['input']>;
  ratingGTE?: InputMaybe<Scalars['Int']['input']>;
  ratingIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  ratingIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  ratingLT?: InputMaybe<Scalars['Int']['input']>;
  ratingLTE?: InputMaybe<Scalars['Int']['input']>;
  ratingNEQ?: InputMaybe<Scalars['Int']['input']>;
  ratingNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  ratingNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** request_id field predicates */
  requestID?: InputMaybe<Scalars['ID']['input']>;
  requestIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  requestIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  requestIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type OneOneSessionRequest = Node & {
  __typename?: 'OneOneSessionRequest';
  appointment?: Maybe<OneOneSessionAppointment>;
  conversation?: Maybe<OneOneSessionConversation>;
  createdAt: Scalars['Time']['output'];
  feedbacks?: Maybe<Array<OneOneSessionFeedback>>;
  id: Scalars['ID']['output'];
  owner: User;
  ownerID: Scalars['ID']['output'];
  sessionTemplate: OneOneSessionTemplate;
  status: OneOneSessionRequestStatus;
  templateID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type OneOneSessionRequestConnection = {
  __typename?: 'OneOneSessionRequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OneOneSessionRequestEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OneOneSessionRequestEdge = {
  __typename?: 'OneOneSessionRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OneOneSessionRequest>;
};

/** OneOneSessionRequestStatus is enum for the field status */
export enum OneOneSessionRequestStatus {
  Cancelled = 'cancelled',
  Submitted = 'submitted'
}

/**
 * OneOneSessionRequestWhereInput is used for filtering OneOneSessionRequest objects.
 * Input was generated by ent.
 */
export type OneOneSessionRequestWhereInput = {
  and?: InputMaybe<Array<OneOneSessionRequestWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** appointment edge predicates */
  hasAppointment?: InputMaybe<Scalars['Boolean']['input']>;
  hasAppointmentWith?: InputMaybe<Array<OneOneSessionAppointmentWhereInput>>;
  /** conversation edge predicates */
  hasConversation?: InputMaybe<Scalars['Boolean']['input']>;
  hasConversationWith?: InputMaybe<Array<OneOneSessionConversationWhereInput>>;
  /** feedbacks edge predicates */
  hasFeedbacks?: InputMaybe<Scalars['Boolean']['input']>;
  hasFeedbacksWith?: InputMaybe<Array<OneOneSessionFeedbackWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** session_template edge predicates */
  hasSessionTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  hasSessionTemplateWith?: InputMaybe<Array<OneOneSessionTemplateWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<OneOneSessionRequestWhereInput>;
  or?: InputMaybe<Array<OneOneSessionRequestWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** status field predicates */
  status?: InputMaybe<OneOneSessionRequestStatus>;
  statusIn?: InputMaybe<Array<OneOneSessionRequestStatus>>;
  statusNEQ?: InputMaybe<OneOneSessionRequestStatus>;
  statusNotIn?: InputMaybe<Array<OneOneSessionRequestStatus>>;
  /** template_id field predicates */
  templateID?: InputMaybe<Scalars['ID']['input']>;
  templateIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  templateIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  templateIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type OneOneSessionTemplate = Node & {
  __typename?: 'OneOneSessionTemplate';
  createdAt: Scalars['Time']['output'];
  durationSeconds: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  ownerID: Scalars['ID']['output'];
  requests?: Maybe<Array<OneOneSessionRequest>>;
  topic?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type OneOneSessionTemplateConnection = {
  __typename?: 'OneOneSessionTemplateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OneOneSessionTemplateEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OneOneSessionTemplateEdge = {
  __typename?: 'OneOneSessionTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OneOneSessionTemplate>;
};

/**
 * OneOneSessionTemplateWhereInput is used for filtering OneOneSessionTemplate objects.
 * Input was generated by ent.
 */
export type OneOneSessionTemplateWhereInput = {
  and?: InputMaybe<Array<OneOneSessionTemplateWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** duration_seconds field predicates */
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsGT?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsGTE?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  durationSecondsLT?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsLTE?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsNEQ?: InputMaybe<Scalars['Int']['input']>;
  durationSecondsNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** requests edge predicates */
  hasRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasRequestsWith?: InputMaybe<Array<OneOneSessionRequestWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<OneOneSessionTemplateWhereInput>;
  or?: InputMaybe<Array<OneOneSessionTemplateWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** topic field predicates */
  topic?: InputMaybe<Scalars['String']['input']>;
  topicContains?: InputMaybe<Scalars['String']['input']>;
  topicContainsFold?: InputMaybe<Scalars['String']['input']>;
  topicEqualFold?: InputMaybe<Scalars['String']['input']>;
  topicGT?: InputMaybe<Scalars['String']['input']>;
  topicGTE?: InputMaybe<Scalars['String']['input']>;
  topicHasPrefix?: InputMaybe<Scalars['String']['input']>;
  topicHasSuffix?: InputMaybe<Scalars['String']['input']>;
  topicIn?: InputMaybe<Array<Scalars['String']['input']>>;
  topicIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  topicLT?: InputMaybe<Scalars['String']['input']>;
  topicLTE?: InputMaybe<Scalars['String']['input']>;
  topicNEQ?: InputMaybe<Scalars['String']['input']>;
  topicNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  topicNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  Asc = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  Desc = 'DESC'
}

/**
 * Information about pagination in a connection.
 * https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type Profession = Node & {
  __typename?: 'Profession';
  company: Scalars['String']['output'];
  department?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  specialty: Array<Scalars['String']['output']>;
  /** Positions like designer, data scientist */
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userPublicProfile: UserPublicProfile;
  userPublicProfileID: Scalars['ID']['output'];
};

/**
 * ProfessionWhereInput is used for filtering Profession objects.
 * Input was generated by ent.
 */
export type ProfessionWhereInput = {
  and?: InputMaybe<Array<ProfessionWhereInput>>;
  /** company field predicates */
  company?: InputMaybe<Scalars['String']['input']>;
  companyContains?: InputMaybe<Scalars['String']['input']>;
  companyContainsFold?: InputMaybe<Scalars['String']['input']>;
  companyEqualFold?: InputMaybe<Scalars['String']['input']>;
  companyGT?: InputMaybe<Scalars['String']['input']>;
  companyGTE?: InputMaybe<Scalars['String']['input']>;
  companyHasPrefix?: InputMaybe<Scalars['String']['input']>;
  companyHasSuffix?: InputMaybe<Scalars['String']['input']>;
  companyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  companyLT?: InputMaybe<Scalars['String']['input']>;
  companyLTE?: InputMaybe<Scalars['String']['input']>;
  companyNEQ?: InputMaybe<Scalars['String']['input']>;
  companyNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** department field predicates */
  department?: InputMaybe<Scalars['String']['input']>;
  departmentContains?: InputMaybe<Scalars['String']['input']>;
  departmentContainsFold?: InputMaybe<Scalars['String']['input']>;
  departmentEqualFold?: InputMaybe<Scalars['String']['input']>;
  departmentGT?: InputMaybe<Scalars['String']['input']>;
  departmentGTE?: InputMaybe<Scalars['String']['input']>;
  departmentHasPrefix?: InputMaybe<Scalars['String']['input']>;
  departmentHasSuffix?: InputMaybe<Scalars['String']['input']>;
  departmentIn?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  departmentLT?: InputMaybe<Scalars['String']['input']>;
  departmentLTE?: InputMaybe<Scalars['String']['input']>;
  departmentNEQ?: InputMaybe<Scalars['String']['input']>;
  departmentNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** user_public_profile edge predicates */
  hasUserPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserPublicProfileWith?: InputMaybe<Array<UserPublicProfileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<ProfessionWhereInput>;
  or?: InputMaybe<Array<ProfessionWhereInput>>;
  /** title field predicates */
  title?: InputMaybe<Scalars['String']['input']>;
  titleContains?: InputMaybe<Scalars['String']['input']>;
  titleContainsFold?: InputMaybe<Scalars['String']['input']>;
  titleEqualFold?: InputMaybe<Scalars['String']['input']>;
  titleGT?: InputMaybe<Scalars['String']['input']>;
  titleGTE?: InputMaybe<Scalars['String']['input']>;
  titleHasPrefix?: InputMaybe<Scalars['String']['input']>;
  titleHasSuffix?: InputMaybe<Scalars['String']['input']>;
  titleIn?: InputMaybe<Array<Scalars['String']['input']>>;
  titleLT?: InputMaybe<Scalars['String']['input']>;
  titleLTE?: InputMaybe<Scalars['String']['input']>;
  titleNEQ?: InputMaybe<Scalars['String']['input']>;
  titleNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_public_profile_id field predicates */
  userPublicProfileID?: InputMaybe<Scalars['ID']['input']>;
  userPublicProfileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userPublicProfileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userPublicProfileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type PublicityEventInput = {
  channel?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  eventID: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  featureFlags: FeatureFlags;
  googleAuthCodeUrl: Scalars['String']['output'];
  groupSession?: Maybe<GroupSession>;
  groupSessionOnlineInfos: GroupSessionOnlineInfoConnection;
  groupSessionRequests: GroupSessionRequestConnection;
  groupSessions: GroupSessionConnection;
  mentorTimetables: MentorTimetableConnection;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Lookup nodes by a list of IDs. */
  nodes: Array<Maybe<Node>>;
  oneOneSessionAppointments: OneOneSessionAppointmentConnection;
  oneOneSessionRequestByID?: Maybe<OneOneSessionRequest>;
  oneOneSessionRequests: OneOneSessionRequestConnection;
  oneOneSessionTemplates: OneOneSessionTemplateConnection;
  refreshUserToken?: Maybe<UserToken>;
  upcomingGroupSessions?: Maybe<Array<Maybe<GroupSession>>>;
  user?: Maybe<User>;
  userPublicProfiles: UserPublicProfileConnection;
  userPublicProfilesPageBased: UserPublicProfileConnection;
  users: UserConnection;
  venues: VenueConnection;
  viewer?: Maybe<User>;
  weeklyCalendars: WeeklyCalendarConnection;
};


export type QueryGroupSessionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGroupSessionOnlineInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GroupSessionOnlineInfoWhereInput>;
};


export type QueryGroupSessionRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GroupSessionRequestWhereInput>;
};


export type QueryGroupSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GroupSessionOrder>;
  where?: InputMaybe<GroupSessionWhereInput>;
};


export type QueryMentorTimetablesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MentorTimetableWhereInput>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryOneOneSessionAppointmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OneOneSessionAppointmentWhereInput>;
};


export type QueryOneOneSessionRequestByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOneOneSessionRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OneOneSessionRequestWhereInput>;
};


export type QueryOneOneSessionTemplatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OneOneSessionTemplateWhereInput>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserPublicProfilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserPublicProfileOrder>;
  where?: InputMaybe<UserPublicProfileWhereInput>;
};


export type QueryUserPublicProfilesPageBasedArgs = {
  limit: Scalars['Int']['input'];
  orderBy?: InputMaybe<UserPublicProfileOrder>;
  page: Scalars['Int']['input'];
  where?: InputMaybe<UserPublicProfileWhereInput>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryVenuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VenueWhereInput>;
};


export type QueryWeeklyCalendarsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WeeklyCalendarWhereInput>;
};

export type Thread = {
  __typename?: 'Thread';
  id: Scalars['String']['output'];
  messages?: Maybe<Array<ThreadMessage>>;
  participants?: Maybe<Array<Scalars['ID']['output']>>;
};

export type ThreadMessage = {
  __typename?: 'ThreadMessage';
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  participantIndex: Scalars['Int']['output'];
  timeUTCSeconds: Scalars['Int']['output'];
};

export type TimeRange = {
  __typename?: 'TimeRange';
  endSeconds: Scalars['Int']['output'];
  startSeconds: Scalars['Int']['output'];
};

export type TimeRangeInput = {
  endSeconds: Scalars['Int']['input'];
  startSeconds: Scalars['Int']['input'];
};

export type UniversityEducation = Node & {
  __typename?: 'UniversityEducation';
  estimatedGraduationYear: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** Major and department */
  major: Scalars['String']['output'];
  schoolName: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  userPublicProfile: UserPublicProfile;
  userPublicProfileID: Scalars['ID']['output'];
  yearOfStudy: UniversityEducationYearOfStudy;
};

/**
 * UniversityEducationWhereInput is used for filtering UniversityEducation objects.
 * Input was generated by ent.
 */
export type UniversityEducationWhereInput = {
  and?: InputMaybe<Array<UniversityEducationWhereInput>>;
  /** estimated_graduation_year field predicates */
  estimatedGraduationYear?: InputMaybe<Scalars['Int']['input']>;
  estimatedGraduationYearGT?: InputMaybe<Scalars['Int']['input']>;
  estimatedGraduationYearGTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedGraduationYearIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  estimatedGraduationYearLT?: InputMaybe<Scalars['Int']['input']>;
  estimatedGraduationYearLTE?: InputMaybe<Scalars['Int']['input']>;
  estimatedGraduationYearNEQ?: InputMaybe<Scalars['Int']['input']>;
  estimatedGraduationYearNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** user_public_profile edge predicates */
  hasUserPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasUserPublicProfileWith?: InputMaybe<Array<UserPublicProfileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** major field predicates */
  major?: InputMaybe<Scalars['String']['input']>;
  majorContains?: InputMaybe<Scalars['String']['input']>;
  majorContainsFold?: InputMaybe<Scalars['String']['input']>;
  majorEqualFold?: InputMaybe<Scalars['String']['input']>;
  majorGT?: InputMaybe<Scalars['String']['input']>;
  majorGTE?: InputMaybe<Scalars['String']['input']>;
  majorHasPrefix?: InputMaybe<Scalars['String']['input']>;
  majorHasSuffix?: InputMaybe<Scalars['String']['input']>;
  majorIn?: InputMaybe<Array<Scalars['String']['input']>>;
  majorLT?: InputMaybe<Scalars['String']['input']>;
  majorLTE?: InputMaybe<Scalars['String']['input']>;
  majorNEQ?: InputMaybe<Scalars['String']['input']>;
  majorNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<UniversityEducationWhereInput>;
  or?: InputMaybe<Array<UniversityEducationWhereInput>>;
  /** school_name field predicates */
  schoolName?: InputMaybe<Scalars['String']['input']>;
  schoolNameContains?: InputMaybe<Scalars['String']['input']>;
  schoolNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  schoolNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  schoolNameGT?: InputMaybe<Scalars['String']['input']>;
  schoolNameGTE?: InputMaybe<Scalars['String']['input']>;
  schoolNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  schoolNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  schoolNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  schoolNameLT?: InputMaybe<Scalars['String']['input']>;
  schoolNameLTE?: InputMaybe<Scalars['String']['input']>;
  schoolNameNEQ?: InputMaybe<Scalars['String']['input']>;
  schoolNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** user_public_profile_id field predicates */
  userPublicProfileID?: InputMaybe<Scalars['ID']['input']>;
  userPublicProfileIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  userPublicProfileIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  userPublicProfileIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** year_of_study field predicates */
  yearOfStudy?: InputMaybe<UniversityEducationYearOfStudy>;
  yearOfStudyIn?: InputMaybe<Array<UniversityEducationYearOfStudy>>;
  yearOfStudyNEQ?: InputMaybe<UniversityEducationYearOfStudy>;
  yearOfStudyNotIn?: InputMaybe<Array<UniversityEducationYearOfStudy>>;
};

/** UniversityEducationYearOfStudy is enum for the field year_of_study */
export enum UniversityEducationYearOfStudy {
  Master_1 = 'master_1',
  Master_2 = 'master_2',
  Master_3 = 'master_3',
  Phd_1 = 'phd_1',
  Phd_2 = 'phd_2',
  Phd_3 = 'phd_3',
  Phd_4 = 'phd_4',
  Undergraduate_1 = 'undergraduate_1',
  Undergraduate_2 = 'undergraduate_2',
  Undergraduate_3 = 'undergraduate_3',
  Undergraduate_4 = 'undergraduate_4',
  Undergraduate_5 = 'undergraduate_5'
}

export type User = Node & {
  __typename?: 'User';
  createdAt: Scalars['Time']['output'];
  emailCredential?: Maybe<EmailCredential>;
  googleCredential?: Maybe<GoogleCredential>;
  groupSessionRequests: GroupSessionRequestConnection;
  id: Scalars['ID']['output'];
  isIntern: Scalars['Boolean']['output'];
  isViewer: Scalars['Boolean']['output'];
  loginSessions?: Maybe<Array<LoginSession>>;
  mentorTimetable?: Maybe<MentorTimetable>;
  ownGroupSessionRequests?: Maybe<Array<GroupSessionRequest>>;
  ownGroupSessions?: Maybe<Array<GroupSession>>;
  ownMentorTimetable?: Maybe<MentorTimetable>;
  ownOneOneSessionFeedbacks?: Maybe<Array<OneOneSessionFeedback>>;
  ownOneOneSessionRequests?: Maybe<Array<OneOneSessionRequest>>;
  ownOneOneSessionTemplates?: Maybe<Array<OneOneSessionTemplate>>;
  ownWeeklyCalendar?: Maybe<WeeklyCalendar>;
  publicProfile?: Maybe<UserPublicProfile>;
  registeredEvents: GroupSessionConnection;
  updatedAt: Scalars['Time']['output'];
};


export type UserGroupSessionRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GroupSessionRequestWhereInput>;
};


export type UserRegisteredEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GroupSessionOrder>;
  where?: InputMaybe<GroupSessionWhereInput>;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A single category of contributions with its count */
export type UserContributions = {
  __typename?: 'UserContributions';
  eventContributions?: Maybe<Scalars['Int']['output']>;
  feedbackContributions?: Maybe<Scalars['Int']['output']>;
  mentoringContributions?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserPublicProfile = Node & {
  __typename?: 'UserPublicProfile';
  biography?: Maybe<Biography>;
  /** Computed contribution metrics for this user */
  contributions: UserContributions;
  firstName: Scalars['String']['output'];
  gender: UserPublicProfileGender;
  goal?: Maybe<UserPublicProfileGoal>;
  id: Scalars['ID']['output'];
  /** Whether the user has completed their public profile setup */
  isComplete: Scalars['Boolean']['output'];
  isOwnedByViewer: Scalars['Boolean']['output'];
  language: Array<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  owner: User;
  ownerID: Scalars['ID']['output'];
  photoDownloadUrl?: Maybe<Scalars['String']['output']>;
  profession?: Maybe<Profession>;
  universityEducation?: Maybe<UniversityEducation>;
  updatedAt: Scalars['Time']['output'];
};

/** A connection to a list of items. */
export type UserPublicProfileConnection = {
  __typename?: 'UserPublicProfileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserPublicProfileEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserPublicProfileEdge = {
  __typename?: 'UserPublicProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserPublicProfile>;
};

/** UserPublicProfileGender is enum for the field gender */
export enum UserPublicProfileGender {
  Female = 'female',
  Male = 'male',
  Unset = 'unset'
}

/** UserPublicProfileGoal is enum for the field goal */
export enum UserPublicProfileGoal {
  Mentee = 'mentee',
  Mentor = 'mentor',
  Networking = 'networking'
}

/** Ordering options for UserPublicProfile connections */
export type UserPublicProfileOrder = {
  /** The ordering direction. */
  direction?: OrderDirection;
  /** The field by which to order UserPublicProfiles. */
  field: UserPublicProfileOrderField;
};

/** Properties by which UserPublicProfile connections can be ordered. */
export enum UserPublicProfileOrderField {
  FirstName = 'FIRST_NAME',
  UpdatedAt = 'UPDATED_AT'
}

/**
 * UserPublicProfileWhereInput is used for filtering UserPublicProfile objects.
 * Input was generated by ent.
 */
export type UserPublicProfileWhereInput = {
  and?: InputMaybe<Array<UserPublicProfileWhereInput>>;
  /** first_name field predicates */
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameContains?: InputMaybe<Scalars['String']['input']>;
  firstNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  firstNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  firstNameGT?: InputMaybe<Scalars['String']['input']>;
  firstNameGTE?: InputMaybe<Scalars['String']['input']>;
  firstNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  firstNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  firstNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  firstNameLT?: InputMaybe<Scalars['String']['input']>;
  firstNameLTE?: InputMaybe<Scalars['String']['input']>;
  firstNameNEQ?: InputMaybe<Scalars['String']['input']>;
  firstNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** gender field predicates */
  gender?: InputMaybe<UserPublicProfileGender>;
  genderIn?: InputMaybe<Array<UserPublicProfileGender>>;
  genderNEQ?: InputMaybe<UserPublicProfileGender>;
  genderNotIn?: InputMaybe<Array<UserPublicProfileGender>>;
  /** goal field predicates */
  goal?: InputMaybe<UserPublicProfileGoal>;
  goalIn?: InputMaybe<Array<UserPublicProfileGoal>>;
  goalIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  goalNEQ?: InputMaybe<UserPublicProfileGoal>;
  goalNotIn?: InputMaybe<Array<UserPublicProfileGoal>>;
  goalNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** biography edge predicates */
  hasBiography?: InputMaybe<Scalars['Boolean']['input']>;
  hasBiographyWith?: InputMaybe<Array<BiographyWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** profession edge predicates */
  hasProfession?: InputMaybe<Scalars['Boolean']['input']>;
  hasProfessionWith?: InputMaybe<Array<ProfessionWhereInput>>;
  /** university_education edge predicates */
  hasUniversityEducation?: InputMaybe<Scalars['Boolean']['input']>;
  hasUniversityEducationWith?: InputMaybe<Array<UniversityEducationWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  languageIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** last_name field predicates */
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameContains?: InputMaybe<Scalars['String']['input']>;
  lastNameContainsFold?: InputMaybe<Scalars['String']['input']>;
  lastNameEqualFold?: InputMaybe<Scalars['String']['input']>;
  lastNameGT?: InputMaybe<Scalars['String']['input']>;
  lastNameGTE?: InputMaybe<Scalars['String']['input']>;
  lastNameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  lastNameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  lastNameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  lastNameLT?: InputMaybe<Scalars['String']['input']>;
  lastNameLTE?: InputMaybe<Scalars['String']['input']>;
  lastNameNEQ?: InputMaybe<Scalars['String']['input']>;
  lastNameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<UserPublicProfileWhereInput>;
  or?: InputMaybe<Array<UserPublicProfileWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  specialtyIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type UserToken = {
  __typename?: 'UserToken';
  authToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

/**
 * UserWhereInput is used for filtering User objects.
 * Input was generated by ent.
 */
export type UserWhereInput = {
  and?: InputMaybe<Array<UserWhereInput>>;
  /** created_at field predicates */
  createdAt?: InputMaybe<Scalars['Time']['input']>;
  createdAtGT?: InputMaybe<Scalars['Time']['input']>;
  createdAtGTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  createdAtLT?: InputMaybe<Scalars['Time']['input']>;
  createdAtLTE?: InputMaybe<Scalars['Time']['input']>;
  createdAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  createdAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  /** email_credential edge predicates */
  hasEmailCredential?: InputMaybe<Scalars['Boolean']['input']>;
  hasEmailCredentialWith?: InputMaybe<Array<EmailCredentialWhereInput>>;
  /** google_credential edge predicates */
  hasGoogleCredential?: InputMaybe<Scalars['Boolean']['input']>;
  hasGoogleCredentialWith?: InputMaybe<Array<GoogleCredentialWhereInput>>;
  /** login_sessions edge predicates */
  hasLoginSessions?: InputMaybe<Scalars['Boolean']['input']>;
  hasLoginSessionsWith?: InputMaybe<Array<LoginSessionWhereInput>>;
  /** own_group_session_requests edge predicates */
  hasOwnGroupSessionRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnGroupSessionRequestsWith?: InputMaybe<Array<GroupSessionRequestWhereInput>>;
  /** own_group_sessions edge predicates */
  hasOwnGroupSessions?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnGroupSessionsWith?: InputMaybe<Array<GroupSessionWhereInput>>;
  /** own_mentor_timetable edge predicates */
  hasOwnMentorTimetable?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnMentorTimetableWith?: InputMaybe<Array<MentorTimetableWhereInput>>;
  /** own_one_one_session_feedbacks edge predicates */
  hasOwnOneOneSessionFeedbacks?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnOneOneSessionFeedbacksWith?: InputMaybe<Array<OneOneSessionFeedbackWhereInput>>;
  /** own_one_one_session_requests edge predicates */
  hasOwnOneOneSessionRequests?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnOneOneSessionRequestsWith?: InputMaybe<Array<OneOneSessionRequestWhereInput>>;
  /** own_one_one_session_templates edge predicates */
  hasOwnOneOneSessionTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnOneOneSessionTemplatesWith?: InputMaybe<Array<OneOneSessionTemplateWhereInput>>;
  /** own_weekly_calendar edge predicates */
  hasOwnWeeklyCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnWeeklyCalendarWith?: InputMaybe<Array<WeeklyCalendarWhereInput>>;
  /** public_profile edge predicates */
  hasPublicProfile?: InputMaybe<Scalars['Boolean']['input']>;
  hasPublicProfileWith?: InputMaybe<Array<UserPublicProfileWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<UserWhereInput>;
  or?: InputMaybe<Array<UserWhereInput>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type Venue = Node & {
  __typename?: 'Venue';
  fullAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mapURL?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  station: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type VenueConnection = {
  __typename?: 'VenueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VenueEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VenueEdge = {
  __typename?: 'VenueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Venue>;
};

/**
 * VenueWhereInput is used for filtering Venue objects.
 * Input was generated by ent.
 */
export type VenueWhereInput = {
  and?: InputMaybe<Array<VenueWhereInput>>;
  /** full_address field predicates */
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  fullAddressContains?: InputMaybe<Scalars['String']['input']>;
  fullAddressContainsFold?: InputMaybe<Scalars['String']['input']>;
  fullAddressEqualFold?: InputMaybe<Scalars['String']['input']>;
  fullAddressGT?: InputMaybe<Scalars['String']['input']>;
  fullAddressGTE?: InputMaybe<Scalars['String']['input']>;
  fullAddressHasPrefix?: InputMaybe<Scalars['String']['input']>;
  fullAddressHasSuffix?: InputMaybe<Scalars['String']['input']>;
  fullAddressIn?: InputMaybe<Array<Scalars['String']['input']>>;
  fullAddressLT?: InputMaybe<Scalars['String']['input']>;
  fullAddressLTE?: InputMaybe<Scalars['String']['input']>;
  fullAddressNEQ?: InputMaybe<Scalars['String']['input']>;
  fullAddressNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** map_url field predicates */
  mapURL?: InputMaybe<Scalars['String']['input']>;
  mapURLContains?: InputMaybe<Scalars['String']['input']>;
  mapURLContainsFold?: InputMaybe<Scalars['String']['input']>;
  mapURLEqualFold?: InputMaybe<Scalars['String']['input']>;
  mapURLGT?: InputMaybe<Scalars['String']['input']>;
  mapURLGTE?: InputMaybe<Scalars['String']['input']>;
  mapURLHasPrefix?: InputMaybe<Scalars['String']['input']>;
  mapURLHasSuffix?: InputMaybe<Scalars['String']['input']>;
  mapURLIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mapURLIsNil?: InputMaybe<Scalars['Boolean']['input']>;
  mapURLLT?: InputMaybe<Scalars['String']['input']>;
  mapURLLTE?: InputMaybe<Scalars['String']['input']>;
  mapURLNEQ?: InputMaybe<Scalars['String']['input']>;
  mapURLNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  mapURLNotNil?: InputMaybe<Scalars['Boolean']['input']>;
  /** name field predicates */
  name?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  nameContainsFold?: InputMaybe<Scalars['String']['input']>;
  nameEqualFold?: InputMaybe<Scalars['String']['input']>;
  nameGT?: InputMaybe<Scalars['String']['input']>;
  nameGTE?: InputMaybe<Scalars['String']['input']>;
  nameHasPrefix?: InputMaybe<Scalars['String']['input']>;
  nameHasSuffix?: InputMaybe<Scalars['String']['input']>;
  nameIn?: InputMaybe<Array<Scalars['String']['input']>>;
  nameLT?: InputMaybe<Scalars['String']['input']>;
  nameLTE?: InputMaybe<Scalars['String']['input']>;
  nameNEQ?: InputMaybe<Scalars['String']['input']>;
  nameNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<VenueWhereInput>;
  or?: InputMaybe<Array<VenueWhereInput>>;
  /** station field predicates */
  station?: InputMaybe<Scalars['String']['input']>;
  stationContains?: InputMaybe<Scalars['String']['input']>;
  stationContainsFold?: InputMaybe<Scalars['String']['input']>;
  stationEqualFold?: InputMaybe<Scalars['String']['input']>;
  stationGT?: InputMaybe<Scalars['String']['input']>;
  stationGTE?: InputMaybe<Scalars['String']['input']>;
  stationHasPrefix?: InputMaybe<Scalars['String']['input']>;
  stationHasSuffix?: InputMaybe<Scalars['String']['input']>;
  stationIn?: InputMaybe<Array<Scalars['String']['input']>>;
  stationLT?: InputMaybe<Scalars['String']['input']>;
  stationLTE?: InputMaybe<Scalars['String']['input']>;
  stationNEQ?: InputMaybe<Scalars['String']['input']>;
  stationNotIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type WeeklyCalendar = Node & {
  __typename?: 'WeeklyCalendar';
  id: Scalars['ID']['output'];
  owner: User;
  ownerID: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
  weeklyTimetable: WeeklyTimetable;
};

/** A connection to a list of items. */
export type WeeklyCalendarConnection = {
  __typename?: 'WeeklyCalendarConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WeeklyCalendarEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WeeklyCalendarEdge = {
  __typename?: 'WeeklyCalendarEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['Cursor']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WeeklyCalendar>;
};

/**
 * WeeklyCalendarWhereInput is used for filtering WeeklyCalendar objects.
 * Input was generated by ent.
 */
export type WeeklyCalendarWhereInput = {
  and?: InputMaybe<Array<WeeklyCalendarWhereInput>>;
  /** owner edge predicates */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  hasOwnerWith?: InputMaybe<Array<UserWhereInput>>;
  /** id field predicates */
  id?: InputMaybe<Scalars['ID']['input']>;
  idGT?: InputMaybe<Scalars['ID']['input']>;
  idGTE?: InputMaybe<Scalars['ID']['input']>;
  idIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  idLT?: InputMaybe<Scalars['ID']['input']>;
  idLTE?: InputMaybe<Scalars['ID']['input']>;
  idNEQ?: InputMaybe<Scalars['ID']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  not?: InputMaybe<WeeklyCalendarWhereInput>;
  or?: InputMaybe<Array<WeeklyCalendarWhereInput>>;
  /** owner_id field predicates */
  ownerID?: InputMaybe<Scalars['ID']['input']>;
  ownerIDIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  ownerIDNEQ?: InputMaybe<Scalars['ID']['input']>;
  ownerIDNotIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** updated_at field predicates */
  updatedAt?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtGTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtIn?: InputMaybe<Array<Scalars['Time']['input']>>;
  updatedAtLT?: InputMaybe<Scalars['Time']['input']>;
  updatedAtLTE?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNEQ?: InputMaybe<Scalars['Time']['input']>;
  updatedAtNotIn?: InputMaybe<Array<Scalars['Time']['input']>>;
};

export type WeeklyTimetable = {
  __typename?: 'WeeklyTimetable';
  friday?: Maybe<Array<TimeRange>>;
  monday?: Maybe<Array<TimeRange>>;
  saturday?: Maybe<Array<TimeRange>>;
  sunday?: Maybe<Array<TimeRange>>;
  thursday?: Maybe<Array<TimeRange>>;
  tuesday?: Maybe<Array<TimeRange>>;
  wednesday?: Maybe<Array<TimeRange>>;
};

export type WeeklyTimetableInput = {
  friday?: InputMaybe<Array<TimeRangeInput>>;
  monday?: InputMaybe<Array<TimeRangeInput>>;
  saturday?: InputMaybe<Array<TimeRangeInput>>;
  sunday?: InputMaybe<Array<TimeRangeInput>>;
  thursday?: InputMaybe<Array<TimeRangeInput>>;
  tuesday?: InputMaybe<Array<TimeRangeInput>>;
  wednesday?: InputMaybe<Array<TimeRangeInput>>;
};
